import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateUserProfile as updateUserProfileApi } from '../../services/apiUserProfile';
import { useAuth } from '../../context/AuthContext';
import { useError } from '../../context/ErrorContext';

export function useUpdateUserProfile() {
  const { handleErrorAction } = useError();
  const { user } = useAuth();
  const clientId = user?.clientId
  const queryClient = useQueryClient();
  const { mutate: updateUserProfile, isLoading, isSuccess } = useMutation({
    mutationFn: (data: {
      userDetailsInfo: string,
      profileImage: File | null
    }) => {
      const {
        userDetailsInfo,
        profileImage
      } = data;
      return updateUserProfileApi({ userDetailsInfo, profileImage, clientId })
    },
    onSuccess: (data) => {
      if (data.status === 200) {
        const { message } = data?.data
        toast.success(message)
        queryClient.invalidateQueries(['profilePicture']);
        queryClient.invalidateQueries(['userData']);
      }
    },
    onError: (error: Error) => {
      handleErrorAction(error)
    }
  });

  return { updateUserProfile, isLoading, isSuccess };
}